
import REact, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

// component functions
import * as ComponentFunctions from './ContractStageTypes.Selector.Functions';
import { Field, InfoLabel, Label, Spinner, Tag, TagPicker, TagPickerControl, TagPickerGroup, TagPickerInput, TagPickerList, TagPickerOption, TagPickerProps } from '@fluentui/react-components';
import { ContractStageType } from '../../../../models/Entities/Contracts/ContractStageType';


const ContractStageTypesSelector = (props: ComponentFunctions.Props) => {

    const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

    useEffect(() => {
        props.GetAllContractsStageTypes();
    }, [props.Types?.length == 0 || props.Types === undefined]);

    useEffect(() => {
        if (props.ContractStageTypeSelected && props.Types) {
            const selectedStageTypes = props.Types.filter((type) => props.ContractStageTypeSelected?.includes(type.id));
            setSelectedOptions(selectedStageTypes?.map((type) => type.name));
        }
    }, [props.ContractStageTypeSelected !== undefined, props.Types]);

    const onOptionSelect: TagPickerProps["onOptionSelect"] = (e, data) => {
        if (data.value === "no-options") {
            setSelectedOptions([]);
            return;
        }
        if (props.MultiselectEnable) {
            setSelectedOptions(data.selectedOptions);
            props.onSelectedType && props.onSelectedType(props.Types?.filter((type: ContractStageType) => data.selectedOptions.includes(type.name)) ?? []);
        } else {
            setSelectedOptions(props.MultiselectEnable ? [data.value] : (selectedOptions.includes(data.value) ? [] : [data.value]));
            props.onSelectedType && props.onSelectedType([props.Types?.find((type: ContractStageType) => type.name === data.value) as ContractStageType]);
        }
    };

    const tagPickerOptions = props.Types?.map((type) => type.name)?.filter(
        (type: string) => !selectedOptions.includes(type)
    ) ?? [];

    return (
        <>
            <Field label="Seleccione un tipo visita" style={{ maxWidth: 400 }}>
                <TagPicker
                    onOptionSelect={onOptionSelect}
                    selectedOptions={selectedOptions}
                >
                    <TagPickerControl
                        secondaryAction={props.isLoading ? <Spinner size="extra-tiny" /> : <></>}
                    >
                        <TagPickerGroup aria-label="visitas seleccionadas">
                            {selectedOptions.map((option) => (
                                <Tag
                                    key={option}
                                    shape="rounded"
                                    value={option}
                                >
                                    {option}
                                </Tag>
                            ))}
                        </TagPickerGroup>
                        <TagPickerInput aria-label="Seleccione una visita" />
                    </TagPickerControl>
                    <TagPickerList>
                        {tagPickerOptions?.length > 0 ? (
                            tagPickerOptions?.map((option) => (
                                <TagPickerOption
                                    value={option}
                                    key={option}
                                >
                                    {option}
                                </TagPickerOption>
                            ))
                        ) : (
                            <TagPickerOption value="no-options">
                                No hay conceptos disponibles
                            </TagPickerOption>
                        )}
                    </TagPickerList>
                </TagPicker>
                {props.noteText && <Label>{props.noteText}</Label>}
            </Field>
            {props.failOnLoading && <InfoLabel
                info={
                    <>
                        <label>{props.error?.ErrorMessage}</label>
                    </>
                }
            ><small style={{ color: 'var(--ichtys-error)' }}>Error al cargar los tipos de visita</small></InfoLabel>}
            {props.noteText && <small>{props.noteText}</small>}
        </>
    );

}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)
    (ContractStageTypesSelector as any);